module.exports = __webpack_public_path__ + "static/site-1783527333127/img/asset_fiscal.a3ed015d.png";